import React from 'react';
import BasePage from '../../../baseClasses/BasePage';
import '../UserSettings.scss';
import './ApplicationInformation.scss';

class ApplicationInformation extends BasePage {
  render() {
    const { isMobile } = this.props;

    return (
      <div className="application-information-container">
        <div className="application-information">
          Application Version | { process.env.VERSION || ''}
        </div>
        <div className="application-information">
          { isMobile && 
            `Native Version | ${ window.cordova ? (window.cordova.appVersion || '') : '' }`
          }
        </div>
      </div>
    );
  }
}

export default (ApplicationInformation);



// WEBPACK FOOTER //
// ./src/components/UserSettings/ApplicationInformation/index.js